module.exports = __webpack_public_path__ + "static/media/APOTHEO_LABO_LA_ROCHE_POSAY.e4481a8f.png";